export const aboutInfo = [
  {
    name: 'Barrionuevo Christian',
    profesion: 'Frontend Developer',
    imagen: './Barrionuevo.png',
    descripcion:
      'Vivo en Bs As , Argentina, capital federal. Me gusta, cuando puedo, ir de viaje y conocer Parques Nacionales, realizar caminatas largas y si es posible acampar. Amante de youtube y reddit.',
    social: {
      linkedin: 'https://www.linkedin.com/in/christianbarrionuevo/',
      github: 'https://github.com/ChrisBarrio',
    },
  },
  {
    name: 'Carrillo Florencia',
    profesion: 'Frontend Developer / Mobile, DBA',
    imagen: './Carrillo.png',
    descripcion:
      'Soy de Córdoba Capital, amo los animales, viajar y codear. Mis actividades favoritas son bailar, cantar y andar en rollers.',
    social: {
      linkedin: 'https://www.linkedin.com/in/florencianoelcarrillo/',
      github: '',
    },
  },
  {
    name: 'Giardili Leandro',
    profesion: 'Java Developer',
    imagen: './Giardili.png',
    descripcion: 'Vivo en Cipolletti Rio Negro, practico yoga.',
    social: {
      linkedin: 'https://www.linkedin.com/in/lea-giardili-23a0451a/',
      github: '',
    },
  },
  {
    name: 'Morilla Vanesa',
    profesion: 'Web developer',
    imagen: './Morilla.png',
    descripcion:
      'Dedicada al desarrollo de aplicaciones web desde el año 2020, enfocada y decidida, autodidacta y en la constante búsqueda de aprender e incorporar nuevos conocimientos. Soy una persona que disfruta del trabajo en equipo, siempre dando lo mejor para alcanzar los objetivos.',
    social: {
      linkedin: 'https://www.linkedin.com/in/vamorilla/',
      github: 'https://github.com/vamorilla',
    },
  },
  {
    name: 'Matias Damian Sanchez Romero',
    profesion: 'Estudiante de Ingeniería Informatica',
    imagen: './Sanchez.png',
    descripcion:
      'Vivo en Catamarca. Me apasiona todo lo relacionado a la tecnología. Mi hobbie en informática es el desarrollo de videojuegos móviles y el uso de ingeniería inversa. Mis pasatiempos: correr y entrenar.',
    social: {
      linkedin: 'https://www.linkedin.com/in/matias-damian-sanchez-romero-798a12214/',
      github: 'https://github.com/matiasdsanchezr',
    },
  },
  {
    name: 'Terzariol Luca',
    profesion: 'Ingeniero Químico/Full Stack Web Developer',
    imagen: './Terzariol.png',
    descripcion:
      'Soy de Córdoba capital, soy ingeniero químico de profesión, fullstack developer de curioso, baterista de gusto y cinturón azul en taekwondo de perseverante. Me gustan los videojuegos y soy muy dulcero.',
    social: {
      linkedin: 'https://www.linkedin.com/in/luca-terzariol-63711239',
      github: 'https://github.com/Teradriel',
    },
  },
  {
    name: 'Varas Lucía',
    profesion: 'Frontend Developer',
    imagen: './Varas.png',
    descripcion:
      'Vivo en la provincia de Córdoba, Argentina. Disfruto mucho cocinar y hacer actividad física en mis tiempos libres.',
    social: {
      linkedin: 'https://www.linkedin.com/in/luc%C3%ADaguillerminavaras/',
      github: 'https://github.com/luvaras6',
    },
  },
];
